// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + (chunkId === "679" ? "__federation_expose_LinkedRecordBase" : chunkId) + "." + {"538": "5c1269a683880c4b","679": "ccd0681e9e46edf7",}[chunkId] + ".css"
}